// @flow

import { get } from 'lodash';

import { type Plan, planTypes } from '@zapier/common-utils';

const getCurrentTrialingPlanId = (
  isTrialing: boolean,
  isTrialingTeams: boolean,
  plans: Plan[]
) => {
  if (!isTrialing) {
    return null;
  }

  if (isTrialingTeams) {
    return plans.find(
      plan =>
        plan.type === planTypes.team || get(plan, 'name', '').includes('Team')
    )?.id;
  }

  return plans.find(
    plan =>
      plan.type === planTypes.professional ||
      get(plan, 'name', '').includes('Professional')
  )?.id;
};

export default getCurrentTrialingPlanId;
